import { useContext } from "react";
import { ReactEvent } from "@mathbuddy/adaptive-practice-events";
import { renderedContext } from "../context/context";
import { IConfig } from "./Render";
export const Circle = ({ cx, cy, radius, stroke, stroke_width, fill, extraProps }: IConfig) => {
    // Shown, not played: see Div.
    const state: any = useContext(renderedContext);
    const isReadOnly = () => state?.readOnly === true;

    const onClick = () => {
        if (isReadOnly()) return;
        // The student has done something to this question - see markTouched in PlayFrame.
        state?.markTouched?.();
        if (extraProps !== null && extraProps.clickable && extraProps.onClick) {
            const reactEvent = new ReactEvent({ id: extraProps.id, extraProps });
            reactEvent.handleEvent(extraProps.onClick);
        }
    }
    const onHover = () => {
        if (isReadOnly()) return;
        if (extraProps !== null && extraProps.clickable && extraProps.onHover) {
            const reactEvent = new ReactEvent({ id: extraProps.id, extraProps });
            reactEvent.handleEvent(extraProps.onHover);
        }
    }
    const onLeave = () => {
        if (isReadOnly()) return;
        if (extraProps !== null && extraProps.clickable && extraProps.onLeave) {
            const reactEvent = new ReactEvent({ id: extraProps.id, extraProps });
            reactEvent.handleEvent(extraProps.onLeave);
        }
    }

    return (
        <circle
            id={extraProps?.id}
            className={extraProps?.className}
            opacity={extraProps?.opacity}
            cx={cx}
            cy={cy}
            r={radius}
            stroke={stroke}
            strokeWidth={stroke_width}
            fill={fill}
            onClick={onClick}
            onMouseEnter={onHover}
            onMouseLeave={onLeave}
        ></circle>
    );
}